import { render, staticRenderFns } from "./EventEditors.vue?vue&type=template&id=1feb8e6f&scoped=true"
import script from "./EventEditors.vue?vue&type=script&lang=ts"
export * from "./EventEditors.vue?vue&type=script&lang=ts"
import style0 from "./EventEditors.vue?vue&type=style&index=0&id=1feb8e6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1feb8e6f",
  null
  
)

export default component.exports